// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historyBlock__CfDZK {
  height: 100%;
}

.blockTitle__mQ53h {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 20px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__fwoUP {
  display: flex;
  flex-direction: column;
  height: 435px;
  overflow-y: auto;
  min-height: 100px;
  position: relative;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}
.blockContainer__fwoUP::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.blockContainer__fwoUP::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.blockContainer__fwoUP::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.blockContainer__fwoUP::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

@media (max-width: 1300px) {
  .blockContainer__fwoUP {
    height: calc(100% - 20px);
  }
}
.filter__aJe0K {
  display: flex;
  padding: 10px 25px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/SensorHistory/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2DAAA;EACA,wCAAA;AAzEF;AAEE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAAJ;AAGE;EACE,+BAAA;EACA,kBAAA;AADJ;AAIE;EACE,8BAAA;EACA,kBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,kBAAA;AAHJ;;AA6DA;EACE;IACE,yBAAA;EA1DF;AACF;AA6DA;EACE,aAAA;EACA,kBAAA;AA3DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.historyBlock {\n  height: 100%;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  display: flex;\n  flex-direction: column;\n  height: 435px;\n  overflow-y: auto;\n  min-height: 100px;\n  position: relative;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n\n  @include scrollBar;\n}\n\n@media (max-width: 1300px) {\n  .blockContainer {\n    height: calc(100% - 20px);\n  }\n}\n\n.filter {\n  display: flex;\n  padding: 10px 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyBlock": `historyBlock__CfDZK`,
	"blockTitle": `blockTitle__mQ53h`,
	"blockContainer": `blockContainer__fwoUP`,
	"filter": `filter__aJe0K`
};
module.exports = ___CSS_LOADER_EXPORT___;
